import { ButtonVariant, IButtonProps } from '@amobee/component-library';
import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
//Constants
import { HourOfDay } from 'src/app/constants/hour-of-day.consts';
import { DayOfWeek } from 'src/app/constants/day-of-week.consts';
const totalDays = 7, totalHours = 24;

@Component({
  selector: 'daypart-targeting',
  templateUrl: './daypart-targeting.component.html',
  styleUrls: ['./daypart-targeting.component.scss']
})
export class DaypartTargetingComponent implements OnInit {

  @Input() group: string;
  @Input() formArray: FormArray;
  daypartMatrixControl: FormControl;
  daypartGrid = Array.from({ length: 24 }, () => Array(7).fill(true));
  open: boolean;
  selectedItems = [];
  saveButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'Save',
    onClick: () => {
      this.saveDaypartTargeting();
    }
  };
  cancelButton: IButtonProps = {
    variant: ButtonVariant.NEUTRAL,
    label: 'Cancel',
    onClick: () => {
      this.cancel();
    }
  };
  label: string = 'Dayparting';
  hideEdit: boolean = false;
  hideRemove: boolean = false;
  constructor() { }

  ngOnInit() {
    this.daypartMatrixControl = this.formArray.controls[this.group].get("daypartMatrix") as FormControl;
    this.convertDaypartMatrixToString();
  }

  openSidebar() {
    if (!this.isDisabled) {
      this.open = true;
      this.daypartGrid = _.cloneDeep(this.daypartMatrixControl.value);
    }
  }

  cancel() {
    this.open = false;
  }

  getHourInfo(hour) {
    return HourOfDay[Object.keys(HourOfDay).find(key => HourOfDay[key].id === hour)];
  };

  convertDaypartMatrixToString() {
    this.selectedItems = [];
    let daypartMatrixData = this.daypartMatrixControl.value;
    for (let d = 0; d < totalDays; d++) {
      let day = (_.invert(DayOfWeek))[d] + " ", slot = '', startTime, hourString = '';
      for (let h = 0; h < totalHours; h++) {
        if (daypartMatrixData[h][d]) {
          // Value True
          if (!startTime) {
            hourString = startTime = this.getHourInfo(h).startRangeName;
            if (h == totalHours - 1) {
              // In case h is last hour of day
              hourString += ' - ' + this.getHourInfo(h).endRangeName;
              startTime = '';
            }
          } else if (h == totalHours - 1) {
            // In case h is last hour of day
            hourString += ' - ' + this.getHourInfo(h).endRangeName;
            startTime = '';
          }
        } else if (startTime) {
          // Value False
          hourString += ' - ' + this.getHourInfo(!h ? 0 : h - 1).endRangeName;
          startTime = '';
        }
        if (hourString && !startTime) {
          if (slot) {
            slot += " , ";
          }
          slot += hourString;
          hourString = '';
        }
      }
      if (slot) {
        let slotData = slot.split(','),
          numberOfSlot = slotData.length;
        if (numberOfSlot > 1) {
          this.selectedItems.push(
            {
              'text': `${day}: ${slotData}`,
              'moreItem': `${slotData.join(',')}`
            }
          );
        } else {
          this.selectedItems.push({ 'text': `${day}: ${slot == '12:00am - 12:00pm' ? "All Day" : slot}` });
        }
      }
    }
  }

  saveDaypartTargeting() {
    if (this.open) {
      this.open = false;
      this.daypartMatrixControl.setValue(this.daypartGrid);
      this.convertDaypartMatrixToString();
    }
  }

  get isDisabled(): boolean {
    return this.daypartMatrixControl.disabled;
  }
}
